import A11yDialog from 'a11y-dialog';
import axios from 'axios';
import firebase from "firebase/app"
import "firebase/auth";
import { UrlUtil } from '../utils/url-util';

import UserSignupView from '../account/signup-view';
import UserSigninView from '../account/signin-view';
import { TrackingUtil } from '../utils/tracking';

import modalMarkup from './modal-wrapper.hbs';

export const ModalTypes = {
    REGISTER: 'register',
    LOGIN: 'login',
    VOUCHER: 'voucher',
    SIGNUP: 'signup'
};

export function Modal() {
    const urlRegister = '/getRegistrationModal.action';
    const urlLogin = '/getLoginModal.action';
    const urlSignup = '/getSignupModal.action';
    const urlVoucher = '/getVoucherCodeModal.action';

    const classModalOpen = 'modal--open';

    const selectorModal = '#modal-dialog';
    const selectorModalContent = '.js-modal-dialog-content-inner';

    const nodeBody = document.body;
    let nodeModal;
    let nodeModalContent;

    let dialog;

    const initializeMarkup = () => nodeBody.insertAdjacentHTML('beforeend', modalMarkup());

    const initializeModal = () => {
        nodeModal = document.querySelector(selectorModal);
        nodeModalContent = document.querySelector(selectorModalContent);

        dialog = new A11yDialog(nodeModal);

        const handleModalShowing = () => nodeBody.classList.add(classModalOpen);
        const handleModalHiding = () => {
            nodeModalContent.innerHTML = '';
            nodeBody.classList.remove(classModalOpen);
            dialog.destroy();
        };

        dialog.on('show', () => handleModalShowing());
        dialog.on('hide', () => handleModalHiding());
    };

    const modalRegister = () => {
        axios.get(urlRegister)
            .then((response) => {
                nodeModal.classList.add('modal--register');
                nodeModalContent.innerHTML = response.data;
                dialog.show();

                // (BEGIN) This has not been refactored yet.
                new UserSignupView();

                // (END) This has not been refactored yet.

                TrackingUtil.throwGAPageview('/Virtual/Signup-Modal/');
            })
            .catch((error) => { });
    };

    const modalLogin = (url) => {
        axios.get(urlLogin)
            .then((response) => {
                nodeModal.classList.add('modal--login');
                nodeModalContent.innerHTML = response.data;
                dialog.show();

                new UserSigninView({ 
                    el: '.js-signin-box', 
                    redirectUrl: (url || location.href)
                });

                let joinButton = document.querySelector(".js-user-join");
                if(url && joinButton) {
                    joinButton.href = UrlUtil.addParameter(joinButton.href, 
                        "redirect", encodeURIComponent(url), true);
                }

                TrackingUtil.throwGAPageview('/Virtual/Signin-Modal/');
            })
            .catch((error) => { });
    };

    const modalSignup = (url) => {
        axios.get(urlSignup)
            .then((response) => {
                nodeModal.classList.add('modal--login');
                nodeModalContent.innerHTML = response.data;
                dialog.show();

                new UserSignupView({ 
                    el: '.js-signup-box', 
                    redirectUrl: (url || location.href) 
                });

                let loginButton = document.querySelector(".js-user-login");
                if(url && loginButton) {
                    loginButton.href = UrlUtil.addParameter(loginButton.href, 
                        "redirect", encodeURIComponent(url), true);
                }

                TrackingUtil.throwGAPageview('/Virtual/Signup-Modal/');
            })
            .catch((error) => { });
    };

    const modalVoucher = (uuid) => {
        axios.get(urlVoucher, {
                params: {
                    productUuid: uuid,
                    dealsSearchPage: !!document.querySelector('.js-voucher')
                }
            })
            .then((response) => {
                nodeModal.classList.add('modal--voucher');
                nodeModalContent.innerHTML = response.data;

                Array.prototype.forEach.call(
                    nodeModal.querySelectorAll(".lazy-image"),
                    image => image.src = image.getAttribute("data-original")
                );

                dialog.show();

                TrackingUtil.throwGAPageview('/Virtual/Voucher-Modal/');
            })
            .catch((error) => { });
    };

    return {

        initializeMarkup,

        show: ({type = '', product = null, productUuid = '', html = '', url = ''}) => {
            initializeModal();

            switch (type) {
                case ModalTypes.REGISTER: modalRegister(); break;
                case ModalTypes.LOGIN: modalLogin(url); break;
                case ModalTypes.SIGNUP: modalSignup(url); break;
                case ModalTypes.VOUCHER: modalVoucher(productUuid); break;
                default: break;
            }
        }
    }
}